import { MaterialChange } from '../../Attribute';
import { AttributeInstance } from './AttributeInstance';

export class MaterialChangeInstance extends AttributeInstance<MaterialChange> {
  constructor(attributeValue: MaterialChange) {
    super(attributeValue);
    this._isApplied = false;
  }
}
